import { Github, X } from "lucide-react";

export function SavedRepos({ items, activeUrl, onOpen, onDelete }) {
  if (!items.length) return null;
  return (
    <div className="mt-4" data-testid="saved-repos">
      <div className="mb-2 font-mono text-[10px] uppercase tracking-widest text-[#737373]">Repositorios guardados</div>
      <div className="flex flex-wrap gap-2">
        {items.map((r) => (
          <div
            key={r.url}
            className={`group inline-flex items-center gap-1 rounded-sm border px-2 py-1 font-mono text-[11px] transition-colors ${
              r.url === activeUrl ? "border-emerald-500/50 bg-emerald-500/10 text-emerald-200" : "border-[#262626] bg-[#121212] text-[#d4d4d4] hover:border-[#404040]"
            }`}
          >
            <button onClick={() => onOpen(r)} className="inline-flex items-center gap-1.5" data-testid={`saved-repo-open-${r.owner}-${r.repo}`}>
              <Github className="h-3 w-3" />
              {r.owner}/{r.repo}
              <span className="text-[#737373]">· {(r.rows || []).length} modelos</span>
            </button>
            <button onClick={() => onDelete(r)} className="ml-1 text-[#737373] hover:text-red-300" data-testid={`saved-repo-delete-${r.owner}-${r.repo}`} aria-label="Eliminar">
              <X className="h-3 w-3" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
